import { render, staticRenderFns } from "./UpdateNumber.vue?vue&type=template&id=dde1b102"
import script from "./UpdateNumber.vue?vue&type=script&lang=js"
export * from "./UpdateNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports